import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import PageContainer from '../../components/PageContainer';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import InvoicesTabs from '../../components/pages/InvoicesPage/InvoicesTabs';
import InvoiceForward from '../../components/pages/InvoicesPage/InvoiceForward';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import {invoicesActions} from '../../state/actions/invoice.actions';
import {objectHelpers} from '../../utils/helpers';

const gObjProp = objectHelpers.getObjProp;

const InvoicesPage = ({
  getInvoicesTotal,
  getInvoicesTotalUnmatched,
}) => {
  const [t] = useTranslation(['invoices', 'main']);
  const [unmatchedTotal, setUnmatchedTotal] = useState({ loading: true });
  const [total, setTotal] = useState({ loading: true });

  useEffect(() => {
    handleUpdateTotal();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const handleUpdateTotal = () => {
    getInvoicesTotal(
      (data) => {
        setTotal({
          all: gObjProp(data, 'total_count', 0),
          matched: gObjProp(data, 'matched_count', 0),
          unmatched: gObjProp(data, 'unmatched_count', 0),
          loading: false,
        });
      },
      () => setTotal({ ...total, loading: false })
    );
    getInvoicesTotalUnmatched(
      (data) => {
        setUnmatchedTotal({
          due: gObjProp(data, 'due_amount', 0),
          overdue: gObjProp(data, 'overdue_amount', 0),
          upcoming: gObjProp(data, 'upcoming_amount', 0),
          loading: false,
        });
      },
      () => setUnmatchedTotal({ ...unmatchedTotal, loading: false })
    );
  }

  return (
    <PageContainer>
      <PageDocumentDetails title={t('main:pageTitles.invoicesList')} />
      <BalancePageHeader breadcrumbs={[{title: t('title')}]} />
      <DashboardPageTransition>
        <InvoiceForward />
        <InvoicesTabs
          handleUpdateTotal={handleUpdateTotal}
          unmatchedTotal={unmatchedTotal}
          total={total}
        />
      </DashboardPageTransition>
    </PageContainer>
  );
}

const mapDispatchToProps = {
  getInvoicesTotal: invoicesActions.getInvoicesTotal,
  getInvoicesTotalUnmatched: invoicesActions.getInvoicesTotalUnmatched,
}

export default connect(null, mapDispatchToProps)(InvoicesPage);
